export enum EPropertySettingTypes {
  AutoId = 'SemantX.MetaApi.Contract.AutoIdPropertySettings, SemantX.MetaApi.Contract',
  Picklist = 'SemantX.MetaApi.Contract.PicklistPropertySettings, SemantX.MetaApi.Contract',
  Date = 'SemantX.MetaApi.Contract.DatePropertySettings, SemantX.MetaApi.Contract',
  Text = 'SemantX.MetaApi.Contract.TextPropertySettings, SemantX.MetaApi.Contract',
  Rational = 'SemantX.MetaApi.Contract.RationalPropertySettings, SemantX.MetaApi.Contract',
  Calculated = 'SemantX.MetaApi.Contract.CalculatedPropertySettings, SemantX.MetaApi.Contract',
  Ownership = 'SemantX.MetaApi.Contract.OwnershipPropertySettings, SemantX.MetaApi.Contract',
  Integer = 'SemantX.MetaApi.Contract.IntegerPropertySettings, SemantX.MetaApi.Contract'
}

export const EPropertySettingTypesLabels: Record<EPropertySettingTypes, string> = {
  [EPropertySettingTypes.AutoId]: 'Auto-ID',
  [EPropertySettingTypes.Picklist]: 'Picklist',
  [EPropertySettingTypes.Date]: 'Date',
  [EPropertySettingTypes.Text]: 'Text',
  [EPropertySettingTypes.Rational]: 'Rational',
  [EPropertySettingTypes.Calculated]: 'Calculated',
  [EPropertySettingTypes.Ownership]: 'Ownership',
  [EPropertySettingTypes.Integer]: 'Integer'
};
